export default __webpack_public_path__ + "static/media/renovetion.27e4310e.png";